import request from './index';

export function wechatLogin(code) {
  return request({
    url: '/weixin/callback',
    method: 'get',
    params: { code },
  });
}

export function submitLoadingInfo(data) {
  return request({
    url: '/shipment/submit',
    method: 'post',
    data: data,
  });
}

export function queryLatestShipment(openId) {
  return request({
    url: '/shipment/query',
    method: 'get',
    params: { openId },
  });
}

export function getLoadingInfoById(id) {
  return request({
    url: `/shipment/status/${id}`,
    method: 'get',
  });
}